import { FC } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import Close from "../../assets/Close.svg";
import { timer } from "helpers/functions";

type PropsType = {
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};

const Bottomsheet: FC<PropsType> = ({ title, children, onClose }) => {
  const { t } = useTranslation("app");

  return (
    <div
      className="bottomsheet-overlay"
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div
        className="bottomsheet-container"
        onClick={(e) => {
          e.stopPropagation();
          timer(0.1).then(() => {
            onClose();
          });
        }}
      >
        <div className="bottomsheet-header">
          <p>{title}</p>
          <button onClick={onClose} aria-label={t("close")}>
            <img src={Close} alt={t("close")} />
          </button>
        </div>

        <div className="bottomsheet-content">{children}</div>
      </div>
    </div>
  );
};

export default Bottomsheet;
